"use client"

import { useAutoAnimate } from "@formkit/auto-animate/react"
import clsx from "clsx"
import { Fragment, useState } from "react"
import { NpHomePageFeatures } from "src/components/home/NpHomePageFeatures"
import { NpProductCarousel } from "src/components/home/NpProductCarousel"
import { NpHomePageTabData } from "src/components/home/types"
import {
  npPageGapClassName,
  npPagePxClassName,
  npSectionMtClassName,
} from "src/components/np-design/components/constants"
import { NpButton } from "src/components/np-design/components/NpButton"
import { NpHeading } from "src/components/np-design/components/NpSubtitle"
import { NpUppercaseHeading } from "src/components/np-design/components/NpUppercaseHeading"

export type NpHomePageTabsSectionProps = {
  tabs: NpHomePageTabData[]
}

export const NpHomePageTabsSection = ({ tabs }: NpHomePageTabsSectionProps) => {
  const [activeIndex, setActiveIndex] = useState(0)
  const [animationParent] = useAutoAnimate()

  const activeTab = tabs[activeIndex]!

  return (
    <section
      className={clsx(npSectionMtClassName, npPagePxClassName, npPageGapClassName, "flex flex-col items-center")}
    >
      <NpUppercaseHeading as="p">Meet Elvent</NpUppercaseHeading>
      <NpHeading as="h2">Höchste Qualität für deine Familienabenteuer.</NpHeading>

      <div className="flex w-full flex-col items-center gap-10">
        <div className="flex flex-wrap justify-center gap-4">
          {tabs.map((tab, index) => {
            const active = index === activeIndex

            return (
              <NpButton
                key={index}
                size="md"
                variant={active ? "filled" : "outlined"}
                onClick={() => setActiveIndex(index)}
              >
                {tab.name}
              </NpButton>
            )
          })}
        </div>

        <div ref={animationParent} className="flex w-full flex-col items-center gap-10 overflow-hidden">
          {tabs.map((tab, index) => {
            if (index !== activeIndex) return null

            return (
              <Fragment key={index}>
                <NpHomePageFeatures features={tab.features} maxDisplayed={3} />
                <NpProductCarousel products={tab.products} maxDisplayed={3} listId="home_featured_products" />
              </Fragment>
            )
          })}
        </div>

        <NpButton variant="outlined" iconNameRight="arrow_forward" href={activeTab.href}>
          Alle {activeTab.name} entdecken
        </NpButton>
      </div>
    </section>
  )
}
